import React from "react";
import { uri } from "../../../help/Api";
import useFetchObjectByPost from "../../../components/Hooks/useFetchObjectByPost";
import { useEffect } from "react";
import BackdropScI from "../../../services/BackdropScI";
import Customers from "./customers";
import useFetchURL from "../../../components/Hooks/useFetchURL";
import { URL } from '../../../api/customer';
import { useLocation } from "react-router-dom";
import { sto } from "../../../Context/InshData";
import LoadingPage from "../../../services/LoadingPage";
export default function CustomersCon() {

    const location = useLocation();
    const type = location.state.setting.type;
    const tb = {
        wait: true,
        Areas: true,
        Cities: true, Countries: true,
        salesmen: true,
        ActsCust: true,
        PermissionsElemnts: true,
        defaultSalesUser: true,
        parms: {
            iempid: sto.empi,
            branch: sto.branchi,
            iuserid: sto.idi,
            iformid: 20001,
            icustmtype: location.state.setting.type,
            db_name: sto?.db_name,
        },

        autos: { Areas: true, Cities: true, Countries: true, salesmens: true, }
    }
    const url = uri + 'Res';

    const { object: data, fetching: fetchinData, fetch } = useFetchObjectByPost(url, tb);
    let Urls = null;
    if (sto.db_name === "" || sto.db_name === null) {
        Urls = `/newAccount?typeAccount=${type}`
    } else {
        Urls = `/newAccount?typeAccount=${type}&&db_name=${sto?.db_name}`
    }
    const { data: newAccount, fetching, fetchURL } = useFetchURL({
        ...{
            url: URL + Urls
        }
    });
    const tb2 = {
        wait: true,
        defaultSalesUser: true,
        UsersA: true,
        Levels: true,
        stor: sto,
        parms: {
            iempid: sto.empi,
            branch: sto.branchi,
            db_name: sto?.db_name,
        },
    };

    const { object: DefaultSalesMan } = useFetchObjectByPost(
        uri + "GetD",
        tb2,
    );

    if (fetchinData || !data?.ActsCust || !DefaultSalesMan.Users || !newAccount || fetching)
        // return <BackdropScI />
        return <LoadingPage />;

    return (
        <Customers
            {...{
                data: { ...data, Acts: data?.ActsCust },
                newAccount,
                fetchinData,
                fetchURL,
                type,
                isDialog: false,
                defaultSalman: { id: DefaultSalesMan?.salesuser?.id, name: DefaultSalesMan?.salesuser?.name, i: 0, isDefault: false },
                isData: false,
                OptionsUsers: DefaultSalesMan?.Users,
                Levels: DefaultSalesMan?.Levels ?? [],
            }} />
    )
}

